/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const NewChatIcon = /*#__PURE__*/ createSvgIcon(
  'NewChatIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M8 4.235c.17 0 .31.139.31.31v2.127h2.128a.31.31 0 010 .62H8.31V9.42a.31.31 0 11-.619 0V7.29H5.563a.31.31 0 110-.619H7.69V4.544c0-.17.139-.31.31-.31z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.88 11.579H4.075l-2.091 2.61a.27.27 0 01-.483-.168V3.995c0-.893.727-1.62 1.62-1.62h9.76c.9 0 1.62.728 1.62 1.62v5.964c0 .9-.727 1.62-1.62 1.62zM2.043 3.995a1.08 1.08 0 011.077-1.078h9.762c.598 0 1.077.484 1.077 1.078v5.964c0 .598-.483 1.078-1.077 1.078H3.939a.271.271 0 00-.236.138l-1.661 2.074V3.995z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M10 4.807c.223 0 .405.181.405.405v2.783h2.784a.405.405 0 110 .81h-2.784v2.782a.405.405 0 11-.81 0V8.804H6.813a.405.405 0 010-.81h2.782V5.213c0-.224.181-.405.405-.405z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.383 14.41H4.866L2.13 17.825a.354.354 0 01-.631-.221V4.493a2.12 2.12 0 012.117-2.118h12.766c1.175 0 2.117.952 2.117 2.118v7.8a2.116 2.116 0 01-2.117 2.117zM2.209 4.493c0-.776.633-1.409 1.408-1.409h12.766c.782 0 1.408.632 1.408 1.409v7.8c0 .782-.632 1.409-1.408 1.409H4.69a.354.354 0 00-.31.18L2.21 16.594V4.493z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M12 5.38a.5.5 0 01.5.5v3.437h3.439a.5.5 0 010 1h-3.44v3.438a.5.5 0 11-1 0v-3.438H8.064a.5.5 0 110-1H11.5V5.879a.5.5 0 01.5-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.884 17.242H5.658L2.279 21.46a.438.438 0 01-.779-.273V4.99a2.62 2.62 0 012.616-2.616h15.768A2.613 2.613 0 0122.5 4.991v9.636a2.613 2.613 0 01-2.616 2.615zM2.376 4.991c0-.958.781-1.74 1.74-1.74h15.768c.966 0 1.74.78 1.74 1.74v9.636c0 .965-.78 1.74-1.74 1.74H5.44a.438.438 0 00-.382.223l-2.682 3.35V4.99z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default NewChatIcon;
